export const ProjectData = [
    {
        key: 1,
        title: "Swift Blade",
        picture: "ProjectPhotos/swift-blade-photo.png",
        description: "A game that is currently in development. The game is a 3d online fighting game that focuses on an"
                     + " offensive play-style. It is being developed using Babylon-js a 3d game engine library, and the code is being written in javascript.",
        link: "https://github.com/ColeBarraclough/sword-fight-game",
        githubLink: "https://github.com/ColeBarraclough/sword-fight-game"
    },
    {
        key: 2,
        title: "Run 2 Auto-Splitter",
        picture: "ProjectPhotos/run-2-photo.jpg",
        description: "An auto-splitter for the popular flash game run 2 developed in c++ and using WxWidgets for the GUI. Using memory management principles, the program isolates the variable that contains the current level in game and waits for it to change. Once the level changes the auto-splitter creates a split and records the time for the segment of the run. It also stores the best times of each split, the times of each split in the best run and the time of the best run to enable the player to race against themselves more accurately.",
        link: "https://github.com/ColeBarraclough/Run2Splitter",
        githubLink: "https://github.com/ColeBarraclough/Run2Splitter"
    },
    {
        key: 3,
        title: "Resume Builder",
        picture: "ProjectPhotos/Cv-project-photo.PNG",
        description: "A project done during my completion of The Odin Project. The Resume Builder is a web appliction to build resumes by allowing a user to create and edit new sections for education and experience. It was developed in react in order to create the education and experience text sections and add them easily.",
        link: "https://colebarraclough.github.io/cv-project/",
        githubLink: "https://github.com/ColeBarraclough/cv-project"
    },
    {
        key: 4,
        title: "MySQL Furniture Database Application",
        picture: "ProjectPhotos/database-photo.PNG",
        description: "Final project for a school course where a MySQL database was developed to create a new piece of furniture using old parts. The old parts and their prices are in the database, the user will request a piece of furniture to be built and the program will determine the cheapest option using set theory.",
        link: "https://github.com/ColeBarraclough/ENSF409FinalProject",
        githubLink: "https://github.com/ColeBarraclough/ENSF409FinalProject"
    },
    {
        key: 5,
        title: "Weather App",
        picture: "ProjectPhotos/weather-app-photo.PNG",
        description: "A project done during my completion of The Odin Project. This project makes use of api's to retrieve data about the current weather conditions in Calgary and displays them in a readable format.",
        link: "https://github.com/ColeBarraclough/WeatherApp",
        githubLink: "https://github.com/ColeBarraclough/WeatherApp"
    },
    {
        key: 6,
        title: "Calculator",
        picture: "ProjectPhotos/calculator-photo.PNG",
        description: "A simple web calculator. The main difficulty of this project was parsing the equation to have proper order of operations. To do this I created a parser that correctly split up each individual operation.",
        link: "https://github.com/ColeBarraclough/Calculator",
        githubLink: "https://github.com/ColeBarraclough/Calculator"
    }
]